<div class="modal-wrapper" data-qa-block="modal-window">
  <ng-container #container></ng-container>
</div>
